/**
 * AI Systems Module
 *
 * Internal module for AI Intelligence Systems - prompt management,
 * feedback collection, A/B testing, deployment pipelines, and discovery.
 */

import type { ModuleManifest } from '../types';
import { routes } from './routes';
import { navItems } from './nav';

// Re-export routes for direct import (used by App.tsx)
export { routes } from './routes';

// =============================================================================
// DISCOVERY COLLECTIONS (for Stream B & C)
// =============================================================================

/**
 * Firestore collection names for Discovery capability
 */
export const DISCOVERY_COLLECTIONS = {
  SESSIONS: 'discovery_sessions',
  INSIGHTS: 'discovery_insights',
  REPORTS: 'landscape_reports',
} as const;

// =============================================================================
// MODULE MANIFEST
// =============================================================================

const aiSystemsModule: ModuleManifest = {
  id: 'AI_SYSTEMS',
  name: 'AI',
  shortName: 'AI',
  description: 'AI Intelligence Systems - prompts, learning, discovery, and deployments',
  icon: '🤖',
  status: 'live',
  urlPrefix: '/ai-systems',
  routes,
  navItems,
  collections: DISCOVERY_COLLECTIONS,
};

export default aiSystemsModule;
